
import { TranslationFunction } from 'widgets-shared/types/core'

export const marketsTranslations = (t: TranslationFunction) => ({
  raceWinner: t('raceWinner.translation', {
    defaultValue: 'Race Winner',
    context: 'Text for raceWinner market type inside Odds Comparison Grid widget'
  }),
  top3: t('top3.translation', {
    defaultValue: 'Top 3',
    context: 'Text for top3 market type inside Odds Comparison Grid widget'
  }),
  top5: t('top5.translation', {
    defaultValue: 'Top 5',
    context: 'Text for top5 market type inside Odds Comparison Grid widget'
  }),
  moneyLine: t('moneyline.translation', {
    defaultValue: 'Moneyline',
    context: 'Text for moneyline market type inside Odds Comparison Grid widget'
  }),
  spread: t('spread.translation', {
    defaultValue: 'Spread',
    context: 'Text for spread market type inside Odds Comparison Grid widget'
  }),
  total: t('total.translation', {
    defaultValue: 'Totals',
    context: 'Text for totals market type inside Odds Comparison Grid widget'
  }),
  overUnder: t('overUnder.translation', {
    defaultValue: 'Totals',
    context: 'Text for Over/Under market type inside Odds Comparison Grid widget'
  })
})
